import { render } from "./BonusHistory.vue?vue&type=template&id=5fbec478&scoped=true"
import script from "./BonusHistory.vue?vue&type=script&lang=js"
export * from "./BonusHistory.vue?vue&type=script&lang=js"

import "./BonusHistory.vue?vue&type=style&index=0&id=5fbec478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbec478"]])

export default __exports__